import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      component: resolve => require(['views/custom/user/login'], resolve)
    },
    {
      path: '/',
      component: resolve => require(['components/container/container'], resolve),
      children: [
        {
          path: 'index',
          name: 'index',
          component: resolve => require(['views/index'], resolve)
        }
      ]
    },
    {
      path: '/custom',
      component: resolve => require(['components/container/container'], resolve),
      children: [
        {
          path: 'updatePassword',
          name: 'updatePassword',
          component: resolve => require(['views/custom/user/updatePassword'], resolve)
        }
      ]
    },
    {
      path: '/page',
      component: resolve => require(['components/container/container'], resolve),
      children: [
        {
          path: 'province',
          component: resolve => require(['components/container/subContainer'], resolve),
          children: [
            {
              path: 'insert',
              name: 'insertProvince',
              component: resolve => require(['views/page/province/html/insert'], resolve)
            },
            {
              path: 'update/:id',
              name: 'updateProvince',
              component: resolve => require(['views/page/province/html/update'], resolve)
            },
            {
              path: 'select',
              name: 'selectProvince',
              component: resolve => require(['views/page/province/html/select'], resolve)
            },
            {
              path: 'detail/:id',
              name: 'detailProvince',
              component: resolve => require(['views/page/province/html/detail'], resolve)
            }
          ]
        },
        {
          path: 'city',
          component: resolve => require(['components/container/subContainer'], resolve),
          children: [
            {
              path: 'insert',
              name: 'insertCity',
              component: resolve => require(['views/page/city/html/insert'], resolve)
            },
            {
              path: 'update/:id',
              name: 'updateCity',
              component: resolve => require(['views/page/city/html/update'], resolve)
            },
            {
              path: 'select',
              name: 'selectCity',
              component: resolve => require(['views/page/city/html/select'], resolve)
            },
            {
              path: 'detail/:id',
              name: 'detailCity',
              component: resolve => require(['views/page/city/html/detail'], resolve)
            }
          ]
        },
        {
          path: 'district',
          component: resolve => require(['components/container/subContainer'], resolve),
          children: [
            {
              path: 'insert',
              name: 'insertDistrict',
              component: resolve => require(['views/page/district/html/insert'], resolve)
            },
            {
              path: 'update/:id',
              name: 'updateDistrict',
              component: resolve => require(['views/page/district/html/update'], resolve)
            },
            {
              path: 'select',
              name: 'selectDistrict',
              component: resolve => require(['views/page/district/html/select'], resolve)
            },
            {
              path: 'detail/:id',
              name: 'detailDistrict',
              component: resolve => require(['views/page/district/html/detail'], resolve)
            }
          ]
        },
        {
          path: 'chatAccount',
          component: resolve => require(['components/container/subContainer'], resolve),
          children: [
            {
              path: 'insert',
              name: 'insertChatAccount',
              component: resolve => require(['views/page/chatAccount/html/insert'], resolve)
            },
            {
              path: 'update/:id',
              name: 'updateChatAccount',
              component: resolve => require(['views/page/chatAccount/html/update'], resolve)
            },
            {
              path: 'select',
              name: 'selectChatAccount',
              component: resolve => require(['views/page/chatAccount/html/select'], resolve)
            },
            {
              path: 'detail/:id',
              name: 'detailChatAccount',
              component: resolve => require(['views/page/chatAccount/html/detail'], resolve)
            }
          ]
        },
        {
          path: 'dayOrder',
          component: resolve => require(['components/container/subContainer'], resolve),
          children: [
            {
              path: 'insert',
              name: 'insertDayOrder',
              component: resolve => require(['views/page/dayOrder/html/insert'], resolve)
            },
            {
              path: 'update/:id',
              name: 'updateDayOrder',
              component: resolve => require(['views/page/dayOrder/html/update'], resolve)
            },
            {
              path: 'select',
              name: 'selectDayOrder',
              component: resolve => require(['views/page/dayOrder/html/select'], resolve)
            },
            {
              path: 'detail/:id',
              name: 'detailDayOrder',
              component: resolve => require(['views/page/dayOrder/html/detail'], resolve)
            }
          ]
        },
        {
          path: 'dayChat',
          component: resolve => require(['components/container/subContainer'], resolve),
          children: [
            {
              path: 'insert',
              name: 'insertDayChat',
              component: resolve => require(['views/page/dayChat/html/insert'], resolve)
            },
            {
              path: 'update/:id',
              name: 'updateDayChat',
              component: resolve => require(['views/page/dayChat/html/update'], resolve)
            },
            {
              path: 'select',
              name: 'selectDayChat',
              component: resolve => require(['views/page/dayChat/html/select'], resolve)
            },
            {
              path: 'detail/:id',
              name: 'detailDayChat',
              component: resolve => require(['views/page/dayChat/html/detail'], resolve)
            }
          ]
        },
        {
          path: 'dayProject',
          component: resolve => require(['components/container/subContainer'], resolve),
          children: [
            {
              path: 'insert',
              name: 'insertDayProject',
              component: resolve => require(['views/page/dayProject/html/insert'], resolve)
            },
            {
              path: 'update/:id',
              name: 'updateDayProject',
              component: resolve => require(['views/page/dayProject/html/update'], resolve)
            },
            {
              path: 'select',
              name: 'selectDayProject',
              component: resolve => require(['views/page/dayProject/html/select'], resolve)
            },
            {
              path: 'detail/:id',
              name: 'detailDayProject',
              component: resolve => require(['views/page/dayProject/html/detail'], resolve)
            }
          ]
        },
        {
          path: 'dayAccount',
          component: resolve => require(['components/container/subContainer'], resolve),
          children: [
            {
              path: 'insert',
              name: 'insertDayAccount',
              component: resolve => require(['views/page/dayAccount/html/insert'], resolve)
            },
            {
              path: 'update/:id',
              name: 'updateDayAccount',
              component: resolve => require(['views/page/dayAccount/html/update'], resolve)
            },
            {
              path: 'select',
              name: 'selectDayAccount',
              component: resolve => require(['views/page/dayAccount/html/select'], resolve)
            },
            {
              path: 'detail/:id',
              name: 'detailDayAccount',
              component: resolve => require(['views/page/dayAccount/html/detail'], resolve)
            }
          ]
        },
        {
          path: 'dayRule',
          component: resolve => require(['components/container/subContainer'], resolve),
          children: [
            {
              path: 'insert',
              name: 'insertDayRule',
              component: resolve => require(['views/page/dayRule/html/insert'], resolve)
            },
            {
              path: 'update/:id',
              name: 'updateDayRule',
              component: resolve => require(['views/page/dayRule/html/update'], resolve)
            },
            {
              path: 'select',
              name: 'selectDayRule',
              component: resolve => require(['views/page/dayRule/html/select'], resolve)
            },
            {
              path: 'detail/:id',
              name: 'detailDayRule',
              component: resolve => require(['views/page/dayRule/html/detail'], resolve)
            }
          ]
        },
        {
          path: 'dayUserChat',
          component: resolve => require(['components/container/subContainer'], resolve),
          children: [
            {
              path: 'insert',
              name: 'insertDayUserChat',
              component: resolve => require(['views/page/dayUserChat/html/insert'], resolve)
            },
            {
              path: 'update/:id',
              name: 'updateDayUserChat',
              component: resolve => require(['views/page/dayUserChat/html/update'], resolve)
            },
            {
              path: 'select',
              name: 'selectDayUserChat',
              component: resolve => require(['views/page/dayUserChat/html/select'], resolve)
            },
            {
              path: 'detail/:id',
              name: 'detailDayUserChat',
              component: resolve => require(['views/page/dayUserChat/html/detail'], resolve)
            }
          ]
        },
        {
          path: 'dayUserProject',
          component: resolve => require(['components/container/subContainer'], resolve),
          children: [
            {
              path: 'insert',
              name: 'insertDayUserProject',
              component: resolve => require(['views/page/dayUserProject/html/insert'], resolve)
            },
            {
              path: 'update/:id',
              name: 'updateDayUserProject',
              component: resolve => require(['views/page/dayUserProject/html/update'], resolve)
            },
            {
              path: 'select',
              name: 'selectDayUserProject',
              component: resolve => require(['views/page/dayUserProject/html/select'], resolve)
            },
            {
              path: 'detail/:id',
              name: 'detailDayUserProject',
              component: resolve => require(['views/page/dayUserProject/html/detail'], resolve)
            }
          ]
        },
        {
          path: 'dayAgentOrder',
          component: resolve => require(['components/container/subContainer'], resolve),
          children: [
            {
              path: 'insert',
              name: 'insertDayAgentOrder',
              component: resolve => require(['views/page/dayAgentOrder/html/insert'], resolve)
            },
            {
              path: 'update/:id',
              name: 'updateDayAgentOrder',
              component: resolve => require(['views/page/dayAgentOrder/html/update'], resolve)
            },
            {
              path: 'select',
              name: 'selectDayAgentOrder',
              component: resolve => require(['views/page/dayAgentOrder/html/select'], resolve)
            },
            {
              path: 'detail/:id',
              name: 'detailDayAgentOrder',
              component: resolve => require(['views/page/dayAgentOrder/html/detail'], resolve)
            }
          ]
        },
        {
          path: 'dayAgentChat',
          component: resolve => require(['components/container/subContainer'], resolve),
          children: [
            {
              path: 'insert',
              name: 'insertDayAgentChat',
              component: resolve => require(['views/page/dayAgentChat/html/insert'], resolve)
            },
            {
              path: 'update/:id',
              name: 'updateDayAgentChat',
              component: resolve => require(['views/page/dayAgentChat/html/update'], resolve)
            },
            {
              path: 'select',
              name: 'selectDayAgentChat',
              component: resolve => require(['views/page/dayAgentChat/html/select'], resolve)
            },
            {
              path: 'detail/:id',
              name: 'detailDayAgentChat',
              component: resolve => require(['views/page/dayAgentChat/html/detail'], resolve)
            }
          ]
        },
        {
          path: 'dayAgentProject',
          component: resolve => require(['components/container/subContainer'], resolve),
          children: [
            {
              path: 'insert',
              name: 'insertDayAgentProject',
              component: resolve => require(['views/page/dayAgentProject/html/insert'], resolve)
            },
            {
              path: 'update/:id',
              name: 'updateDayAgentProject',
              component: resolve => require(['views/page/dayAgentProject/html/update'], resolve)
            },
            {
              path: 'select',
              name: 'selectDayAgentProject',
              component: resolve => require(['views/page/dayAgentProject/html/select'], resolve)
            },
            {
              path: 'detail/:id',
              name: 'detailDayAgentProject',
              component: resolve => require(['views/page/dayAgentProject/html/detail'], resolve)
            }
          ]
        },
        {
          path: 'leaveMessage',
          component: resolve => require(['components/container/subContainer'], resolve),
          children: [
            {
              path: 'insert',
              name: 'insertLeaveMessage',
              component: resolve => require(['views/page/leaveMessage/html/insert'], resolve)
            },
            {
              path: 'update/:id',
              name: 'updateLeaveMessage',
              component: resolve => require(['views/page/leaveMessage/html/update'], resolve)
            },
            {
              path: 'select',
              name: 'selectLeaveMessage',
              component: resolve => require(['views/page/leaveMessage/html/select'], resolve)
            },
            {
              path: 'detail/:id',
              name: 'detailLeaveMessage',
              component: resolve => require(['views/page/leaveMessage/html/detail'], resolve)
            }
          ]
        },
      ]
    },
    {
      path: '/business',
      component: resolve => require(['components/container/container'], resolve),
      children: [
      ]
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js